import { render, staticRenderFns } from "./invoicesetting.vue?vue&type=template&id=f9f0cc50&scoped=true"
import script from "./invoicesetting.vue?vue&type=script&lang=js"
export * from "./invoicesetting.vue?vue&type=script&lang=js"
import style0 from "./invoicesetting.vue?vue&type=style&index=0&id=f9f0cc50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f0cc50",
  null
  
)

export default component.exports